import { createFileRoute } from '@tanstack/react-router'
import { BrandsListPage } from '@/features/account/pages/brands/brands-list-page'

export interface BrandsListSearch {
  /** E2 create-brand dialog open. */
  'create-brand'?: boolean
  /** Fully visible parent selected by a detail/header creation entry point. */
  'parent-brand'?: string
  /**
   * Send the caller to the newly-created brand's page when the dialog closes.
   * Set by first-time-setup entry points that want the brand's detail page to
   * be the natural next surface, not the brands list.
   */
  'redirect-on-create'?: boolean
}

/** E1 — Brands list (the E2 create dialog rides as a search-param overlay). */
export const Route = createFileRoute('/_ws/w/$workspaceId/brands/')({
  validateSearch: (search: Record<string, unknown>): BrandsListSearch => ({
    'create-brand':
      search['create-brand'] === true || search['create-brand'] === 'true' ? true : undefined,
    'parent-brand':
      typeof search['parent-brand'] === 'string' && search['parent-brand'].trim()
        ? search['parent-brand']
        : undefined,
    'redirect-on-create':
      search['redirect-on-create'] === true || search['redirect-on-create'] === 'true'
        ? true
        : undefined,
  }),
  component: BrandsListPage,
})
